import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const useDataRequestsByAppType = (isAmr: boolean) => {
    return (dataRequests: IDataRequest[]): IDataRequest[] => {
        let filteredDataRequests: IDataRequest[];
        if (isAmr) {
            filteredDataRequests = dataRequests.filter((a) => a.antimicrobialDetail !== null);
        } else {
            // @ts-expect-error works as intended
            filteredDataRequests = dataRequests.filter((a) => !a.antimicrobialDetail || a.antimicrobialDetail === 'Undefined');
        }

        return filteredDataRequests;
    };
};
